// Pure helpers for conversation annotation regions.
//
// Unlike VAD's tiled segments, these regions are independent and MAY OVERLAP —
// they come straight from wavesurfer's RegionsPlugin (drag-select/resize/move),
// so there's no split/merge/boundary math here, just label bookkeeping and
// serialization. A region is { id, start, end, labels[] }.

export const LABELS = [
  "off_topic",
  "low_engagement",
  "language_change",
  "child_input_ignored",
  "too_slow",
  "high_latency",
  "repetition",
  "stops_in_between",
  "highly_engaged",
  "others",
];
export const FREE_TEXT_LABEL = "others";

export function toggleLabel(regions, id, label) {
  return regions.map((r) => {
    if (r.id !== id) return r;
    const has = r.labels.includes(label);
    return { ...r, labels: has ? r.labels.filter((l) => l !== label) : [...r.labels, label] };
  });
}

// Vacuously true for an empty list — no regions marked means "no issues found".
export function allLabeled(regions) {
  return regions.every((r) => r.labels.length > 0);
}

// Serialize to the submit shape, sorted by start. Overlap is preserved as-is —
// there's no coverage/tiling invariant to enforce. `note` (free text for the
// "others" tag) is only included when non-empty.
export function toAnnotations(regions, precision = 6) {
  const round = (n) => parseFloat(n.toFixed(precision));
  return [...regions]
    .sort((a, b) => a.start - b.start)
    .map((r) => {
      const out = { start: round(r.start), end: round(r.end), labels: [...r.labels] };
      if (r.note) out.note = r.note;
      return out;
    });
}
